import { Component, OnInit } from '@angular/core'
import { UserContextService } from '@core/service/user-context.service'
import { UserInfo } from '@shared/models'
import { getRole } from '@shared/utils/degts-utils'

@Component({
  selector: 'app-info-user',
  templateUrl: './info-user.component.html',
  styleUrls: ['./info-user.component.scss'],
})
export class InfoUserComponent implements OnInit {
  userInfo: UserInfo

  constructor(private userContext: UserContextService) {}

  ngOnInit(): void {
    this.loadUserInfo()
  }

  loadUserInfo() {
    this.userInfo = {
      name: this.userContext.userInfo.nome,
      role: this.getCargo(),
      hospital:
        this.userContext.vinculoAtual?.instituicao.nomeFantasia ||
        this.userContext.residenteUser?.instituicao.nomeFantasia,
    }
  }

  get isDegts() {
    return this.userContext.hasRole(getRole('ROLE_DEGTS'))
  }

  get isDev() {
    return this.userContext.hasRole(getRole('ROLE_DEV'))
  }

  get isFinanceiro() {
    return this.userContext.hasRole(getRole('ROLE_FINANCEIRO'))
  }

  get isTransferencia() {
    return this.userContext.hasRole(getRole('ROLE_TRANSFERENCIA'))
  }

  get isAdministrador() {
    return this.userContext.isAdministrador()
  }

  getCargo() {
    if (this.userContext.isResidente()) {
      return 'Residente'
    } else if (this.isDegts) {
      return 'DEGTS'
    } else if (this.isFinanceiro) {
      return 'Financeiro'
    } else if (this.isTransferencia) {
      return 'Transferências'
    } else if (this.isDev) {
      return 'Developer mode'
    } else if (this.isAdministrador) {
      return 'Administrador'
    } else {
      const vinculoAtual = this.userContext.vinculoAtual
      let nomePrograma = ''
      let sigla = ''

      if (this.userContext.isSupervisor()) {
        nomePrograma = vinculoAtual.programa?.nomePrograma
        const cargo = vinculoAtual.programa.programaId ? 'Coordenador(a) do programa' : 'Supervisor(a) do programa'
        return `${cargo} de ${nomePrograma}`
      }
      if (this.userContext.isCoordenador()) {
        sigla = vinculoAtual.comissao?.tipoComissao.sigla
      }

      return `Coordenador(a) ${sigla}`
    }
  }
}
